import "./../../api/clients/init";
import "./../../errors/global";
import type { AppBootstrapProps } from "@mittwald/flow-components/dist/components/AppBootstrap";
import { AppBootstrap } from "@mittwald/flow-components/dist/components/AppBootstrap";
import type { FC } from "react";
import React from "react";
import type { WidgetRendererProps } from "./WidgetRenderer";
import { WidgetRenderer } from "./WidgetRenderer";

export const WidgetRendererBootstrap: FC<
  WidgetRendererProps & AppBootstrapProps
> = (props) => {
  const { container, lazyComponents, ...bootstrapProps } = props;
  return (
    <AppBootstrap
      environment={import.meta.env.MODE}
      sentryDsn={import.meta.env.VITE_APP_SENTRY_DSN}
      useShadowDom
      version={import.meta.env.VITE_APP_MSTUDIO_VERSION}
      {...bootstrapProps}
    >
      <WidgetRenderer container={container} lazyComponents={lazyComponents} />
    </AppBootstrap>
  );
};

export default WidgetRendererBootstrap;
